<script lang="ts" setup>
defineProps<{
  link: {
    url: string
    target: string
    text: string
  }
}>()
</script>
<template>
  <div class="card">
    <slot />
    <div class="sliding-content">
      <slot name="sliding" />
    </div>
    <NuxtLink :to="link.url" :target="link.target" class="link" />
  </div>
</template>
<style lang="scss" scoped>
.card {
  position: relative;
  overflow: hidden;

  @include breakpoint(ds) {
    --slide: 0;
    @include hover {
      --slide: var(--p-mb);
      :deep(.title),
      :deep(.type) {
        color: var(--c-blue-rollover);
      }
    }
  }

  :deep(.title),
  :deep(.type) {
    color: var(--c-primary);
  }
  :deep(.type) {
    display: block;
  }
  :deep(.title) {
    margin-bottom: 8px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  :deep(.description) {
    margin-top: 24px;

    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;

    > * {
      font-size: inherit;
      line-height: inherit;
      letter-spacing: inherit;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.sliding-content {
  position: relative;
  padding-bottom: var(--slide);
  @include transitions(margin, padding);
}

.link {
  @include fill;

  z-index: 1;
}
</style>
